import React from 'react';
import { Box, Flex, Text, FontSize } from '@tapresearch/ui/components';
import { TapQuestion } from '../../api';
import { QuestionNumber } from '../common/QuestionNumber';
import useAsset from '../hook/useAsset';

interface QuestionResultWrapperProps {
  tapQuestion: TapQuestion['attributes'];
  headerRightContent?: React.ReactElement;
  totalRespondents?: number;
  isLongitudinalView?: boolean;
}
export const QuestionResultWrapper: React.FC<QuestionResultWrapperProps> = ({
  children,
  tapQuestion,
  headerRightContent,
  totalRespondents,
  isLongitudinalView = false,
  ...rest
}) => {
  const { active_enum } = useAsset();

  const questionType =
    active_enum.TapAnswerType[
      tapQuestion.tap_answer_type.toString() as keyof typeof active_enum.TapAnswerType
    ];
  return (
    <Box
      {...{
        bg: 'white',
        boxShadow: 'md',
        mb: 8,
        pb: isLongitudinalView ? 0 : 8,
        ...rest,
      }}
      data-testid="question-result-wrapper"
    >
      <Flex
        p={6}
        pb={0}
        fontSize="lg"
        fontWeight="medium"
        color="gray.800"
        justify="space-between"
        align="flex-start"
      >
        <Flex align="center">
          <QuestionNumber
            textStyles={{ color: 'blue.500', fontWeight: 'medium' }}
            num={tapQuestion.position}
          />
          <Box>
            {tapQuestion.question_text}
            <Flex
              {...{
                fontSize: '14px' as FontSize,
                color: 'gray.400',
                fontWeight: 'normal',
                p: 0,
                top: '8px',
                my: 1,
                position: 'relative',
              }}
            >
              {questionType}{' '}
              {tapQuestion.allows_multiple_selection && '(multi-select)'}
              {totalRespondents && (
                <Box ml={10}>
                  Responses:{' '}
                  <Text fontWeight="semibold" color="gray.700">
                    {totalRespondents}
                  </Text>
                </Box>
              )}
            </Flex>
          </Box>
        </Flex>
        <Flex align="right">{headerRightContent}</Flex>
      </Flex>

      <Flex w="full" data-testid="chart-container">
        {children}
      </Flex>
    </Box>
  );
};
